import ProvinceSelector from './ProvinceSelector';
export default ProvinceSelector;
